/* unplugin-vue-components disabled */import { render } from "./finances.vue?vue&type=template&id=7b5690e7&scoped=true"
import script from "./finances.vue?vue&type=script&setup=true&lang=js"
export * from "./finances.vue?vue&type=script&setup=true&lang=js"

import "./finances.vue?vue&type=style&index=0&id=7b5690e7&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5690e7"],['__file',"src/components/cards/company/finances.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b5690e7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b5690e7', __exports__)) {
    api.reload('7b5690e7', __exports__)
  }
  
  module.hot.accept("./finances.vue?vue&type=template&id=7b5690e7&scoped=true", () => {
    api.rerender('7b5690e7', render)
  })

}


export default __exports__